import { WorkspaceMapDto } from '@mark43/cad-api';
import { GeoPoint } from '../location/types';
import { WorkspaceWindowActionDelegate, WorkspaceMapFilters } from './types';

export class WorkspaceMap implements WorkspaceMapDto {
    workspaceWindowId: number;
    agencyProfileFilters: WorkspaceMapDto['agencyProfileFilters'] = [];
    agencyTypeFilters: WorkspaceMapDto['agencyTypeFilters'] = [];
    centerLatitude: WorkspaceMapDto['centerLatitude'];
    centerLongitude: WorkspaceMapDto['centerLongitude'];
    dispatchAreaFilters: WorkspaceMapDto['dispatchAreaFilters'] = [];
    layerFilters: WorkspaceMapDto['layerFilters'] = [];
    mapUnitStatusFilters: WorkspaceMapDto['mapUnitStatusFilters'] = [];
    primarySubdivisionFilters: WorkspaceMapDto['primarySubdivisionFilters'] = [];
    priorityFilters: WorkspaceMapDto['priorityFilters'] = [];
    zoomLevel: WorkspaceMapDto['zoomLevel'];
    delegate: WorkspaceWindowActionDelegate;

    constructor({
        workspaceWindowId,
        workspaceMapDto,
        delegate,
    }: {
        workspaceWindowId: number;
        workspaceMapDto?: WorkspaceMapDto;
        delegate: WorkspaceWindowActionDelegate;
    }) {
        this.workspaceWindowId = workspaceWindowId;
        this.delegate = delegate;
        this.updateWorkspaceMap(workspaceMapDto);
    }

    public updateWorkspaceMap(workspaceMapDto?: WorkspaceMapDto) {
        this.agencyProfileFilters = workspaceMapDto?.agencyProfileFilters ?? [];
        this.agencyTypeFilters = workspaceMapDto?.agencyTypeFilters ?? [];
        this.centerLatitude = workspaceMapDto?.centerLatitude;
        this.centerLongitude = workspaceMapDto?.centerLongitude;
        this.dispatchAreaFilters = workspaceMapDto?.dispatchAreaFilters ?? [];
        this.layerFilters = workspaceMapDto?.layerFilters ?? [];
        this.mapUnitStatusFilters = workspaceMapDto?.mapUnitStatusFilters ?? [];
        this.primarySubdivisionFilters = workspaceMapDto?.primarySubdivisionFilters ?? [];
        this.priorityFilters = workspaceMapDto?.priorityFilters ?? [];
        this.zoomLevel = workspaceMapDto?.zoomLevel;
    }

    public getDto(): WorkspaceMapDto {
        return {
            agencyProfileFilters: this.agencyProfileFilters,
            agencyTypeFilters: this.agencyTypeFilters,
            centerLatitude: this.centerLatitude,
            centerLongitude: this.centerLongitude,
            dispatchAreaFilters: this.dispatchAreaFilters,
            layerFilters: this.layerFilters,
            mapUnitStatusFilters: this.mapUnitStatusFilters,
            primarySubdivisionFilters: this.primarySubdivisionFilters,
            priorityFilters: this.priorityFilters,
            zoomLevel: this.zoomLevel,
        };
    }

    public updateMapFilters(filters: WorkspaceMapFilters) {
        this.agencyProfileFilters = filters.agencyProfileFilters;
        this.agencyTypeFilters = filters.agencyTypeFilters;
        this.dispatchAreaFilters = filters.dispatchAreaFilters;
        this.mapUnitStatusFilters = filters.mapUnitStatusFilters;
        this.primarySubdivisionFilters = filters.primarySubdivisionFilters;
        this.priorityFilters = filters.priorityFilters;
        this.delegate.enqueueSaveWorkspaceWindow?.(this.workspaceWindowId);
    }

    public updateMapLayers(layers: WorkspaceMapDto['layerFilters']) {
        this.layerFilters = layers;
        this.delegate.enqueueSaveWorkspaceWindow?.(this.workspaceWindowId);
    }

    public updateMapCenter(mapCenter: GeoPoint, zoomLevel?: number) {
        this.centerLatitude = mapCenter.latitude;
        this.centerLongitude = mapCenter.longitude;
        if (zoomLevel !== undefined) {
            this.zoomLevel = zoomLevel;
        }
        this.delegate.enqueueSaveWorkspaceWindow?.(this.workspaceWindowId);
    }

    public updateMapZoomLevel(zoomLevel: WorkspaceMapDto['zoomLevel']) {
        this.zoomLevel = zoomLevel;
        this.delegate.enqueueSaveWorkspaceWindow?.(this.workspaceWindowId);
    }
}
